import type { SpherePotionId, SphereSpellId } from './sphereDuel';

export type SphereIconAction =
  | { kind: 'cast'; spell: SphereSpellId }
  | { kind: 'potion'; potion: SpherePotionId };

export interface SphereHotbarDefinition {
  readonly label: string;
  readonly action: SphereIconAction;
  readonly source: 'gump' | 'static';
  readonly artId: number;
}

/**
 * The fixed Sphere hotbar in key order.
 *
 * Spell icons are the classic spellbook Gumps at 0x8c0 + (spell number - 1),
 * where spells number 1-64 alphabetically within each circle (so circle 1 is
 * Clumsy 0x8c0, Create Food 0x8c1, ..., Magic Arrow 0x8c4).
 * Potion icons are their classic static-art bottle graphics.
 */
export const SPHERE_HOTBAR: readonly SphereHotbarDefinition[] = [
  { label: 'Magic Arrow', action: { kind: 'cast', spell: 'magic-arrow' }, source: 'gump', artId: 0x8c4 },
  { label: 'Poison', action: { kind: 'cast', spell: 'poison' }, source: 'gump', artId: 0x8d3 },
  { label: 'Lightning', action: { kind: 'cast', spell: 'lightning' }, source: 'gump', artId: 0x8dd },
  { label: 'Flame Strike', action: { kind: 'cast', spell: 'flame-strike' }, source: 'gump', artId: 0x8f2 },
  { label: 'Greater Heal', action: { kind: 'cast', spell: 'greater-heal' }, source: 'gump', artId: 0x8dc },
  { label: 'Cure', action: { kind: 'cast', spell: 'cure' }, source: 'gump', artId: 0x8ca },
  { label: 'Greater Heal Potion', action: { kind: 'potion', potion: 'greater-heal' }, source: 'static', artId: 0x0f0c },
  { label: 'Mana Potion', action: { kind: 'potion', potion: 'mana' }, source: 'static', artId: 0x0f09 },
] as const;

export function sphereIconFile(definition: SphereHotbarDefinition): string {
  return `${definition.source}-${definition.artId.toString(16).padStart(4, '0')}.webp`;
}
